// extracted by mini-css-extract-plugin
export default {"PopoverContent":"_PopoverContent--_u1DJ","PopoverArrow":"_PopoverArrow--Y6lBA","fade":"_fade--rBlRv"};